import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d9f9a8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "workout-card-title" }
const _hoisted_2 = ["title"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-chevron-left",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "workout-card-title" }
const _hoisted_6 = { class: "workout-title-date" }
const _hoisted_7 = {
  key: 0,
  class: "workout-title"
}
const _hoisted_8 = {
  key: 1,
  class: "workout-title"
}
const _hoisted_9 = { class: "workout-segment" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" — ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-map-marker",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_12 = { class: "workout-date" }
const _hoisted_13 = { class: "workout-link" }
const _hoisted_14 = ["title"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-chevron-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]

import { toRefs } from 'vue'

  import authApi from '@/api/authApi'
  import { ISport } from '@/types/sports'
  import { IWorkoutObject } from '@/types/workouts'

  interface Props {
    sport: ISport
    workoutObject: IWorkoutObject
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    sport: null,
    workoutObject: null
  },
  emits: ['displayModal'],
  setup(__props: any, { emit }) {

const props = __props as {
    sport: ISport
    workoutObject: IWorkoutObject
  }

  

  

  const { sport, workoutObject } = toRefs(props)

  async function downloadGpx(workoutId: string) {
    await authApi
      .get(`workouts/${workoutId}/gpx/download`, {
        responseType: 'blob',
      })
      .then((response) => {
        const gpxFileUrl = window.URL.createObjectURL(
          new Blob([response.data], { type: 'application/gpx+xml' })
        )
        const gpxLink = document.createElement('a')
        gpxLink.href = gpxFileUrl
        gpxLink.setAttribute('download', `${workoutId}.gpx`)
        document.body.appendChild(gpxLink)
        gpxLink.click()
      })
  }

return (_ctx: any,_cache: any) => {
  const _component_SportImage = _resolveComponent("SportImage")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["workout-previous workout-arrow", { inactive: !_unref(workoutObject).previousUrl }]),
      title: 
        _unref(workoutObject).previousUrl
          ? _ctx.$t(`workouts.PREVIOUS_${_unref(workoutObject).type}`)
          : _ctx.$t(`workouts.NO_PREVIOUS_${_unref(workoutObject).type}`)
      ,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (
        _unref(workoutObject).previousUrl
          ? _ctx.$router.push(_unref(workoutObject).previousUrl)
          : null
      ))
    }, _hoisted_4, 10, _hoisted_2),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_SportImage, {
        "sport-label": _unref(sport).label,
        color: _unref(sport).color
      }, null, 8, ["sport-label", "color"]),
      _createElementVNode("div", _hoisted_6, [
        (_unref(workoutObject).type === 'WORKOUT')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("span", null, _toDisplayString(_unref(workoutObject).title), 1),
              _createElementVNode("i", {
                class: "fa fa-edit",
                "aria-hidden": "true",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (
              _ctx.$router.push({
                name: 'EditWorkout',
                params: { workoutId: _unref(workoutObject).workoutId },
              })
            ))
              }),
              (_unref(workoutObject).with_gpx)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "fa fa-download",
                    "aria-hidden": "true",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (downloadGpx(_unref(workoutObject).workoutId)), ["prevent"]))
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("i", {
                class: "fa fa-trash",
                "aria-hidden": "true",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('displayModal', true)))
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createTextVNode(_toDisplayString(_unref(workoutObject).title) + " ", 1),
              _createElementVNode("span", _hoisted_9, [
                _hoisted_10,
                _hoisted_11,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('workouts.SEGMENT')) + " " + _toDisplayString(_unref(workoutObject).segmentId + 1), 1)
              ])
            ])),
        _createElementVNode("div", _hoisted_12, [
          _createTextVNode(_toDisplayString(_unref(workoutObject).workoutDate) + " - " + _toDisplayString(_unref(workoutObject).workoutTime) + " ", 1),
          _createElementVNode("span", _hoisted_13, [
            (_unref(workoutObject).type === 'SEGMENT')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: {
                name: 'Workout',
                params: { workoutId: _unref(workoutObject).workoutId },
              }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" > " + _toDisplayString(_ctx.$t('workouts.BACK_TO_WORKOUT')), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["workout-next workout-arrow", { inactive: !_unref(workoutObject).nextUrl }]),
      title: 
        _unref(workoutObject).nextUrl
          ? _ctx.$t(`workouts.NEXT_${_unref(workoutObject).type}`)
          : _ctx.$t(`workouts.NO_NEXT_${_unref(workoutObject).type}`)
      ,
      onClick: _cache[4] || (_cache[4] = ($event: any) => (
        _unref(workoutObject).nextUrl ? _ctx.$router.push(_unref(workoutObject).nextUrl) : null
      ))
    }, _hoisted_16, 10, _hoisted_14)
  ]))
}
}

})